import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";
function EQSOrderConfirmationDetail({conValue, confirm, bid_value }: any) {
  const form = useAppSelector((state) => state.orderSection.form_data);
  return (
    <>
      <div className="order-confirmation-table">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              <td>
                <span>{confirm.security_name}</span>
                <div className="tooltiptext">
                  <p>{confirm.security_name}</p>
                </div>
              </td>
              <td>{form.direction.toUpperCase()}</td>
              <td>{form.order_type.toUpperCase()}</td>
              <td>
                <span>{confirm.time.replace(/_/g, " ")}</span>
              </td>
              <td>
                <>
                  {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "sell" && <b>{Number(confirm.price).toFixed(2)}</b>}</>
                  )}
                </>
              </td>
             
              <td>{!conValue ? <b>{formatNumber(confirm.quantity)}</b> : <b>{formatNumber(confirm.quantity)} (Lot size 1 = {new Intl.NumberFormat().format(conValue?.Multiplier)})</b>}</td>
                          
              
             {!conValue ? <td>
                {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                  <b>N/A</b>
                ) : (
                  <>
                    {form.direction.toLowerCase() === "sell" && (
                      <b>
                        ({new Intl.NumberFormat().format(confirm.quantity * confirm.price)}) {confirm.currency}
                      </b>
                    )}
                  </>
                )}
              </td>
            :
            <td className="w-[200px]">
            {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
              <b>N/A</b>
            ) : (
              <>
                {form.direction.toLowerCase() === "sell" && (
                  <b>
                    ({new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)}) {confirm.currency}
                  </b>
                )}
              </>
            )}
          </td>
            }
            </tr>
          </tbody>
        </table>
        <>
          {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
            <></>
          ) : (
            <>
            {!conValue ? (
              <>
                {form.direction.toLowerCase() === "sell" && (
                  <p>
                    At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                    {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} {confirm.currency}
                  </p>
                )}
              </>
            ) : (
              <>
                {form.direction.toLowerCase() === "sell" && (
                  <p>
                    At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                    {new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)} {confirm.currency}
                  </p>
                )}
              </>
            )}
          </>
          )}
        </>
      </div>
    </>
  );
}

export default EQSOrderConfirmationDetail;
